<template lang="pug">
    v-row
        v-col.col-12.col-md-6(v-for="(item, index) in dataCollection" :key="index")
            line-chart(:chart-data="item")
</template>

<script>
    import LineChart from '~components/LineChart';
    import VueTypes from 'vue-types';
    import dayjs from 'dayjs';
    import randomFlatColors from 'random-flat-colors';

    export default {
        components: {
            LineChart,
        },
        props: {
            chartData: VueTypes.array.def([]),
        },
        computed: {
            dataCollection() {
                if (!this.chartData.length) return [];
                let collection = [];
                this.chartData.forEach((item) => {
                    const prices = item.prices.sort(
                        (a, b) => b.days_from_present - a.days_from_present
                    );
                    const dataSet = {
                        label: item.symbol,
                        backgroundColor: randomFlatColors([
                            'orange',
                            'blue',
                            'teal',
                            'green',
                            'purple',
                        ]),
                        data: [],
                    };

                    const labels = [];
                    const datasets = [];

                    prices.forEach((o) => {
                        dataSet.data.push(o.settlement_price * 1);
                        labels.push(
                            dayjs()
                                .subtract(o.days_from_present, 'day')
                                .format('MM/DD/YY')
                        );
                    });

                    datasets.push(dataSet);

                    const oneChartData = {
                        labels,
                        datasets,
                    };

                    collection.push(oneChartData);
                });

                return collection;
            },
        },
    };
</script>
